import React, { useState, useEffect, useRef } from "react";
import { withNamespaces } from "react-i18next";
import axios from "axios";
import $ from "jquery";
import SettingsPopUp from "./SettingsPopUp.js";
import { confirmAlert } from "react-confirm-alert"; // Import

const SettingsModusZeitTable = (props) => {
  let link = localStorage.getItem("link");

  let data = props.data;
  let type = props.type;

  const [modusZeits, setModusZeits] = useState();
  const [popUpShow, setPopUpShow] = useState(false);
  const [currentModusZeitData, setCurrentModusZeitData] = useState();
  const popUpContainer = useRef(null);

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("JWT");
  }, [localStorage.getItem("JWT")]);

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    await axios
      .get(link + "/api/" + type + "/mode-timer?elementId=" + data.id)
      .then((response) => {
        setModusZeits(response.data);
      });
  }

  $(document).on("click", function (e) {
    if (
      popUpContainer.current &&
      !popUpContainer.current.contains(e.target) &&
      e.target.id != "settings-icon" &&
      !$(e.target).is(".settings-item") &&
      !$(e.target).children().hasClass("settings-item") &&
      !$(e.target).hasClass("select-icon") &&
      !$(e.target).parents(".rc-time-picker-panel").length == 1 &&
      !$(e.target).hasClass("rc-time-picker-clear") &&
      !$(e.target).hasClass("rc-time-picker-clear-icon") &&
      e.target.id != "pop-up-button"
    ) {
      setPopUpShow(false);
    }
  });

  function editCreateModusZeit(modusZeitData, elementId) {
    modusZeitData.elementId = elementId;
    setCurrentModusZeitData(modusZeitData);
    setPopUpShow(true);
  }

  const deleteModusZeit = (modusZeitData) => {
    let timerId = modusZeitData.timerId;

    confirmAlert({
      message: props.t("allgemein.bestaetigen"),
      buttons: [
        {
          label: props.t("allgemein.ja"),
          onClick: () =>
            axios
              .delete(link + "/api/" + type + "/mode-timer?timerId=" + timerId)
              .then((response) => {
                // getData();
              })

              .catch((error) => {}),
        },
        {
          label: props.t("allgemein.nein"),
        },
      ],
    });
  };

  function modusZeitsList() {
    let modusZeitsList = [];

    for (let i = 0; i < modusZeits.length; i++) {
      const daysOfWeek = [
        props.t("allgemein.tageKurz.Sunday"),
        props.t("allgemein.tageKurz.Monday"),
        props.t("allgemein.tageKurz.Tuesday"),
        props.t("allgemein.tageKurz.Wednesday"),
        props.t("allgemein.tageKurz.Thursday"),
        props.t("allgemein.tageKurz.Friday"),
        props.t("allgemein.tageKurz.Saturday"),
      ];
      const chosenDaysOfWeek = modusZeits[i].weekdays
        .map(function (v, i) {
          return daysOfWeek[v];
        })
        .join(",");

      modusZeitsList.push(
        <tr key={"key_" + i}>
          <td>
            {modusZeits[i].startTime} - {modusZeits[i].endTime}
          </td>
          <td>{chosenDaysOfWeek}</td>
          <td>
            {modusZeits[i].mode == 0 && props.t("lot.modes.Automatic")}
            {modusZeits[i].mode == 1 && props.t("lot.modes.ManualFree")}
            {modusZeits[i].mode == 2 && props.t("lot.modes.ManualOccupied")}
          </td>
          <td>
            <button
              className="button"
              id="pop-up-button"
              style={{ width: "80px" }}
              onClick={() => editCreateModusZeit(modusZeits[i], data.id)}
            >
              {props.t("allgemein.bearbeiten")}
            </button>
            <button
              className="button"
              id="pop-up-button"
              style={{ width: "80px", marginLeft: "10px" }}
              onClick={() => deleteModusZeit(modusZeits[i])}
            >
              {props.t("allgemein.loeschen")}
            </button>
          </td>
        </tr>
      );
    }

    return <tbody>{modusZeitsList}</tbody>;
  }

  function popUpChange() {
    getData();
    setPopUpShow(false);
  }

  return (
    <>
      {popUpShow == true && (
        <div ref={popUpContainer}>
          {
            <SettingsPopUp
              popUpType={"modusZeit"}
              type={type}
              data={currentModusZeitData}
              onChange={popUpChange}
            >
              {" "}
            </SettingsPopUp>
          }
        </div>
      )}
      <div className="settings-groups">
        <div className="settings-name">
          {props.t("allgemein.modus")} {props.t("allgemein.zeitsteuerung")}
        </div>
        <table id="barrierTable">
          <thead>
            <tr>
              <th>{props.t("allgemein.zeitraum")}</th>
              <th>{props.t("allgemein.wochentage")}</th>
              <th>{props.t("allgemein.modus")}</th>
              <th>
                <button
                  className="button"
                  id="pop-up-button"
                  style={{ width: "50px" }}
                  onClick={() => editCreateModusZeit({}, data.id)}
                >
                  {props.t("allgemein.neu")}
                </button>
              </th>
            </tr>
          </thead>
          {modusZeits && modusZeitsList()}
        </table>
      </div>
    </>
  );
};

export default withNamespaces()(SettingsModusZeitTable);
